import CryptoJS from 'crypto-js'

// 依環境變數區分不同專案/不同發布環境的金鑰，避免所有專案、所有環境共用同一把寫死的 key
// 找不到對應 .env 設定時才退回舊有的寫死值，確保未設定時不會直接壞掉
const SECRET_KEY =
  import.meta.env.VITE_SECURE_SECRET_KEY || 'dc8aZdW9T9GM/D7tdGgkcIhhtxdxHkjGA+kEQL4gLgg='

// 專案識別碼：不同系統專案即使共用同一 hostname:port，儲存 key 也不會互相碰撞
const PROJECT_ID = import.meta.env.VITE_SECURE_PROJECT_ID || 'crmV1'

/**
 * 處理 pinia 加解密問題
 */
export const securePiniaStorage = {
  prefix: (key: string) => {
    const hostname = window.location.hostname
    const port = window.location.port || 'port' // 獲取端口號
    const url = new URL(window.location.href)
    const allowedDomains = ['eztrust.tw']

    // 防止重複 多一層 KEY (校稿區)
    let pathSegments = 'x'

    // 判斷是否在 校稿區
    const isMatch = allowedDomains.some((domain) =>
      new RegExp(`(^|\\.)${domain}$`, 'i').test(hostname)
    )

    if (isMatch) {
      const _pathSegments = url.pathname.split('/').filter(Boolean)
      pathSegments = _pathSegments[0] || ''
    }

    // 依據網域 + 專案識別碼產生的 KEY
    return `${PROJECT_ID}_${hostname}_${port}_${pathSegments}_${key}`
      .replace(/\./g, '_')
      .replace(/[^a-zA-Z0-9.-_]/g, '')
  },
  storage: {
    getItem: (key) => {
      const encryptedData = localStorage.getItem(key)
      if (encryptedData) {
        try {
          const decryptedData = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY).toString(
            CryptoJS.enc.Utf8
          )
          return JSON.parse(decryptedData)
        } catch (error) {
          console.error('Error decrypting data:', error)
          return null
        }
      }
      return null
    },
    setItem: (key, value) => {
      const jsonData = JSON.stringify(value)
      const encryptedData = CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString()
      localStorage.setItem(key, encryptedData)
    }
  }
}
